import state from './state';
import getters from './getters';
import mutations from './mutations';
import actions from './actions';
import { WeatherState } from './types';
import { Module } from 'vuex';
import { RootState } from '../types';

export const weather: Module<WeatherState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
